<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-btn x-large color="success" v-if="!usuarioActual.Loggeado" @click="irALogin">Iniciar sesión</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import store from '../store'
import router from '../router'
export default {
  name: 'Home',
  computed: {
      usuarioActual() {
        return store.state.usuarios.usuarioActual
      }
  },
  methods: {
      irALogin() {
        router.replace("/Login")
      }
  },
  created() {
    store.dispatch('actualizarTituloPrincipal', process.env.VUE_APP_Nombre)
    if (!store.state.usuarios.usuarioActual.Loggeado) {
      router.replace('/Login')
    }
  }
}
</script>
